import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { instagramUrl, whatsappLink } from '../data/mock';

export default function Footer() {
  return (
    <footer className="bg-[color:var(--brown-900)] pt-20 pb-8 border-t border-[color:var(--gold-500)]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-3 gap-12 pb-12">
          <div>
            <div className="font-serif italic text-6xl text-[color:var(--gold-400)] tracking-widest leading-none">
              AR
            </div>
            <div className="mt-6 font-serif tracking-widest-2 text-[color:var(--cream-100)]">
              ANA RODRIGUES
            </div>
            <div className="text-[10px] tracking-widest-2 text-[color:var(--gold-400)]/80 uppercase mt-1">
              Social Media
            </div>
          </div>

          <div className="md:justify-self-center">
            <p className="text-[color:var(--cream-100)] font-medium">Ana Rodrigues</p>
            <p className="text-[color:var(--cream-100)]/70 mt-3">Social Media & Videomaker</p>
            <p className="text-[color:var(--cream-100)]/70">Belo Horizonte · MG, Brasil</p>
          </div>

          <div className="md:justify-self-end flex flex-col gap-3 text-[color:var(--cream-100)]">
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 group hover:text-[color:var(--gold-400)] transition-colors"
            >
              Instagram
              <ArrowUpRight
                size={16}
                className="text-[color:var(--gold-400)] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 group hover:text-[color:var(--gold-400)] transition-colors"
            >
              WhatsApp
              <ArrowUpRight
                size={16}
                className="text-[color:var(--gold-400)] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
            <a
              href="#portfolio"
              className="inline-flex items-center gap-2 group hover:text-[color:var(--gold-400)] transition-colors"
            >
              Portfólio de Vídeos
              <ArrowUpRight
                size={16}
                className="text-[color:var(--gold-400)] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-[color:var(--gold-500)]/15">
          <p className="text-[10px] tracking-widest-2 text-[color:var(--cream-100)]/60 uppercase">
            © 2026 Ana Rodrigues Social Media. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
